<template>
  <div class="main">
    <el-form @submit.native.prevent="onSubmit" :model="formPendencia" ref="formPendencia" label-position="top" >
        <div>
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Pendência atual">
                        <el-input readonly v-model="$CONSTANTS.HISTORICO_PENDENTE[matPendHistorico]">
                            {{ $CONSTANTS.HISTORICO_PENDENTE[matPendHistorico] }}
                        </el-input>
                    </el-form-item>
                </el-col> 
            </el-row> 

            <el-row :gutter="10">
                <el-col :xs="24" class="u-mt-15">
                    <el-form-item prop="historico_pendente" label="Pendência nova">
                        <el-select v-model="formPendencia.historico_pendente" placeholder="Selecione uma opção">
                            <el-option label="FALTANDO" :value="0">FALTANDO</el-option>
                            <el-option label="CONFECCIONAR" :value="1">CONFECCIONAR</el-option>
                            <el-option label="RECEBIDO" :value="2">RECEBIDO</el-option>
                            <el-option label="ENTREGUE" :value="3">ENTREGUE</el-option>
                            <el-option label="PRONTO P/ ENTREGA" :value="4">PRONTO P/ ENTREGA</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="primary" id="btn-pendencia-historico" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
    </el-form>
  </div>
</template>

<script>
  export default {
    props: {
      visible: {      
      required: true
      },
      matPendHistorico: {        
        required: true
      },
      formPendencia: {        
        required: true
      },      
    },
    data() {
      return {
        rules: {
          historico_pendente: [
            { required: true, message: 'Por favor, selecione uma opção', trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      onSubmit() {
        document.getElementById("btn-pendencia-historico").focus();

            this.$refs.formPendencia.validate( async (valid) => { if(valid){

                try{

                    let dados = this.formPendencia;  
                    let res;

                    window.eventBus.$emit('loading', true);

                    res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/updatePendenciaHistorico/` + dados.id_matricula, dados, this.$store.getters.getHeaderAuth);


                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                    this.$emit('onSubmit');

                   

                }catch(e){ window.eventBus.$emit('loading', false); this.$store.commit('throwException', e); console.error(e); }

            }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});

            
        }
    }
  }
</script>
